module.exports = __webpack_public_path__ + "img/16_002.4ccdeec6.webp";